define('app-ContactUs/main',['./settings'],
       function (settings) {
           return {
               run: function () {
                   var self = this;
                   self.settings = settings;
                   if ($(settings.container).length === 0) {
                       window.log('No contact us div located. Contact us not be available');
                       return;
                   }

                   $(settings.contactOptionLink).on('click', function () {
                       $(this).parent().parent(settings.contactOptions).next(settings.contactDetails).show();
                       $(settings.contactOptions).hide();
                   });

                   $(settings.showAllContactOps).on('click', function () {
                       $(settings.contactOptions).show();
                       $(settings.contactDetails).hide();
                   });

               }
           }
       });
